import React, { Component } from 'react';

class Hello extends Component {

    constructor(props){
        super(props);
    }

    render() {
        return (
            <div className="Hello">
                <p>Hello {this.props.name}!</p>
            </div>
        );
    }
}

export default Hello;
